import { IonButton, IonInput, IonItem, IonLabel } from "@ionic/react";
import * as React from "react";

import styles from "./EditPasswordField.module.scss";

export interface EditPasswordFieldProps {
  value: string;
  error: string;
  onChange: (e: any) => void;
  cancel: () => void;
}

export const EditPasswordField = (props: EditPasswordFieldProps) => {
  const [state, setState] = React.useState({ showPassword: false });
  return (
    <>
      <IonItem>
        <IonLabel>パスワード</IonLabel>
        {state.showPassword && (
          <>
            <IonInput
              name="password"
              type="password"
              onIonChange={props.onChange}
              className={styles.input}
            />
            {state.showPassword && (
              <IonButton
                className={styles.changeButton}
                fill="outline"
                onClick={() => {
                  setState({ showPassword: false });
                  props.cancel();
                }}
              >
                キャンセル
              </IonButton>
            )}
          </>
        )}
        {!state.showPassword && (
          <>
            <IonLabel className={styles.attributeValue} slot="end">
              *****
            </IonLabel>
            {!state.showPassword && (
              <IonButton
                className={styles.changeButton}
                fill="outline"
                slot="end"
                onClick={() => {
                  setState({ showPassword: true });
                }}
              >
                変更する
              </IonButton>
            )}
          </>
        )}
      </IonItem>
      <div className={props.error && styles.invalidFeedback}>{props.error}</div>
    </>
  );
};

export default EditPasswordField;
